import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import {
  type ThreeWayMatchSearch,
  threeWayMatchSearchFrom,
} from '@/features/purchasing-reports/api'
import { ThreeWayMatchReportScreen } from '@/features/purchasing-reports/three-way-match-report'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/purchasing/reports/three-way-match')({
  validateSearch: (search: Record<string, unknown>): ThreeWayMatchSearch =>
    threeWayMatchSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'purchase_order.view')) {
      throw redirect({ to: '/purchasing/orders' })
    }
  },
  component: ThreeWayMatchRoute,
})

function ThreeWayMatchRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <ThreeWayMatchReportScreen
      search={search}
      onSearchChange={(next) =>
        void navigate({ to: '/purchasing/reports/three-way-match', search: next })
      }
    />
  )
}
